import { config } from '@iheartjane/config';

import { requestWithoutErrorHandling } from '@jane/monolith/utils/request';

export const ResetPasswordRequestSource = {
  create: (email: string) => {
    const url = `${config.apiPath}/reset_password_request`;

    return requestWithoutErrorHandling(url, {
      body: JSON.stringify({ email }),
      method: 'POST',
    });
  },
};
